import { render } from "./menu.vue?vue&type=template&id=431cc1b0&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=431cc1b0&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=431cc1b0&lang=scss"
script.render = render
script.__scopeId = "data-v-431cc1b0"

export default script